import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../components/layout/Layout';
import SEO from '../components/seo/SEO';
import ProductGrid from '../components/products/ProductGrid';
import ProductGridSkeleton from '../components/products/ProductGridSkeleton';
import { getNewArrivals } from '../services/products';
import { useToast } from '../hooks/use-toast';
import { BRAND_NAME } from '../lib/brand';

const NewArrivalsPage = () => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const newProducts = await getNewArrivals();
        setProducts(newProducts);
      } catch (error) {
        console.error('Error fetching new arrivals:', error);
        toast({
          title: 'Hata',
          description: 'Ürünler yüklenirken bir sorun oluştu. Lütfen sayfayı yenileyin.',
          variant: 'destructive',
        });
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [toast]);

  return (
    <Layout>
      <SEO
        title={`${BRAND_NAME} | Yeni Ürünler`}
        description={`${BRAND_NAME} yeni ürün koleksiyonu. En yeni moda trendlerini keşfedin. Hızlı kargo ve güvenli alışveriş.`}
      />
      <div className="w-full max-w-[1600px] mx-auto py-6 sm:py-8">
        <div className="mb-12 px-3 text-center sm:px-4 md:px-6 lg:px-8">
          <span className="inline-block text-blue-600 text-sm font-medium tracking-wider uppercase mb-2">
            Yeni Koleksiyon
          </span>
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">Yeni Ürünler</h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            En yeni moda trendlerini keşfedin. Her hafta yeni ürünler ekleniyor.
          </p>
        </div>

        {/* Products */}
        {loading ? (
          <ProductGridSkeleton columns={4} count={12} />
        ) : products.length > 0 ? (
          <ProductGrid products={products} columns={4} />
        ) : (
          <div className="px-3 py-12 text-center sm:px-4">
            <p className="text-gray-500 text-lg mb-4">
              Şu anda yeni ürün bulunmamaktadır.
            </p>
            <p className="text-gray-400">
              Yakında yeni ürünler eklenecek, tekrar kontrol edin!
            </p>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default NewArrivalsPage;